var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-accounts",
    transform: "translate(-5.359 -5.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2227",
    "data-name": "Rectangle 2227",
    width: 18,
    height: 18,
    transform: "translate(5.359 5.359)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6784",
    "data-name": "Path 6784",
    d: "M-5715.641-1911.318a8.719,8.719,0,0,1,8.708-8.708,8.719,8.719,0,0,1,8.709,8.708,8.72,8.72,0,0,1-8.709,8.71A8.72,8.72,0,0,1-5715.641-1911.318Zm8.708,6.71a6.677,6.677,0,0,0,4.117-1.416,3.265,3.265,0,0,0-.937-1.251,4.8,4.8,0,0,0-3.2-1.119,4.654,4.654,0,0,0-3.153,1.112,3.1,3.1,0,0,0-.918,1.279A6.674,6.674,0,0,0-5706.932-1904.608Zm-6.709-6.71a6.673,6.673,0,0,0,1.16,3.767,5.62,5.62,0,0,1,1.058-1.233,6.343,6.343,0,0,1,1.927-1.158,3.521,3.521,0,0,1-.967-2.426,3.537,3.537,0,0,1,3.533-3.533,3.536,3.536,0,0,1,3.531,3.533,3.521,3.521,0,0,1-.979,2.439,6.225,6.225,0,0,1,3.009,2.361,6.672,6.672,0,0,0,1.147-3.749,6.718,6.718,0,0,0-6.71-6.709A6.718,6.718,0,0,0-5713.641-1911.318Zm5.177-1.051a1.535,1.535,0,0,0,1.534,1.532,1.533,1.533,0,0,0,1.532-1.532,1.533,1.533,0,0,0-1.532-1.532A1.535,1.535,0,0,0-5708.464-1912.37Z",
    transform: "translate(5721.291 1925.677)",
    fill: "#222a41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccounts);
export default __webpack_public_path__ + "static/media/icon_accounts.c9518e3b.svg";
export { ForwardRef as ReactComponent };